module.exports = __webpack_public_path__ + "img/08.dc65ac3a.png";